import { createFileRoute, redirect } from "@tanstack/react-router";
import { withQuery } from "@/lib/redirect-query";

// Legacy/menu URL — permanently redirect to the consumer rights request page.
export const Route = createFileRoute("/consumer-rights")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: withQuery("/consumer-rights-request/", location.searchStr), statusCode: 301 });
  },
});
